import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabasePublicKey = import.meta.env.VITE_SUPABASE_PUBLIC_KEY as string;

if (!(supabaseUrl && supabasePublicKey)) {
	throw new Error("Missing VITE_SUPABASE_URL or VITE_SUPABASE_PUBLIC_KEY environment variables");
}

export const supabase = createClient(supabaseUrl, supabasePublicKey);
